import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4e08aec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "location-page" }
const _hoisted_2 = { class: "operation" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "auto-text ws_ml4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "map_location",
  class: "map"
}, null, -1))

import { ref, onMounted, onUnmounted, watch } from 'vue'
import {
  createPopup,
  createMap,
  getDeviceClass,
  formatLat,
  formatLng,
} from '@/utils/map.utils'
import { CODE_ENUM, PRODUCT_TYPE } from '@/common/enum'
import { ElMessage } from 'element-plus'
import {
  queryLocusTreeList,
  queryAllDevice,
  queryBatchDeviceLocation,
} from '@/api'
import MapControl from '@/components/map-control'
import moment from 'moment'
import i18n from '@/i18n'
import L from 'leaflet'
import OrgSelect from '@/components/org-select'
// import '@/utils/m'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const formRef = ref()

// 已选设备

const formInline = ref({
  deviceIds: [],
  orgId: '',
})

const onOrgChange = () => {
  formInline.value.deviceIds = []
  queryDevice()
}

const resetForm = () => {
  formRef.value?.resetFields?.()
  queryDevice()
  queryDeviceLocation()
}

let map: any = null
onMounted(async () => {
  map = createMap('map_location')
  queryDevice()
  queryDeviceLocation()

  map.on('zoomend', () => {
    markerEntity.value.map((marker: any) => {
      const latLng = marker.entity?.getLatLng?.()
      marker?.entity?.setLatLng?.(latLng)
    })
  })
})

const deviceOps: any = ref([])
const queryDevice = async () => {
  const res: any = await queryLocusTreeList({
    orgId: formInline.value.orgId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    deviceOps.value = res?.data || []
  }
}

// 设备列表
const deviceList: any = ref([])
const queryDeviceLocation = async () => {
  const { orgId, deviceIds } = formInline.value
  const res: any = await queryBatchDeviceLocation({
    orgId,
    deviceIds,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    deviceList.value = res?.data || []
    createDeviceMaker()
  }
}

const markerEntity: any = ref([])
// 移除设备
const clearAllMarker = () => {
  markerEntity.value.forEach((marker: any) => {
    marker.entity.remove()
  })
}

// 渲染设备
const createDeviceMaker = () => {
  clearAllMarker()
  markerEntity.value = []
  deviceList.value.forEach((device: any) => {
    const marker: any = createMarker(device)
    // 这里要存储一个产品类型
    markerEntity.value.push({
      id: device.deviceId,
      entity: marker,
    })
  })

  if (deviceList.value.length !== 0) {
    map.fitBounds(getPoints(deviceList.value))
  } else {
    const latlng = new L.LatLng(22.646419, 114.090136)
    map.panTo(latlng)
    map.setView(latlng, 6)
    ElMessage.warning(t('D_LOCATION.msgNoLocation'))
  }

  renderDevice()
}

// 渲染合适的entity -> 类型合适
const renderDevice = () => {
  clearAllMarker()
  markerEntity.value.forEach((marker: any) => {
    marker.entity.addTo(map)
  })
}

const createMarker = (device: any) => {
  const { latitude, longitude, picCode } = device

  console.log(latitude, 'latitudelatitudelatitude')
  const marker = L.marker([latitude, longitude], {
    icon: new L.divIcon({
      iconSize: [49, 62],
      iconAnchor: [25, 60],
      className: 'map-' + picCode,
    }),
  })
  const popup = createPopup(device)

  marker.bindPopup(popup)
  marker.off('click')
  marker.on('click', async (e: any) => {
    const { latlng } = e
    popup.setContent(`
      <div>${t('D_LOCATION.device')}：${device.deviceName}</div>
      <div>${t('D_LOCATION.address')}：${device.deviceAddress || '-'}</div>
      <div>${t('D_LOCATION.lat')}：${
      formatLat(device.latitude) + ' ' + device.latitude + '°'
    }</div>
      <div>${t('D_LOCATION.lng')}：${
      formatLng(device.longitude) + ' ' + device.longitude + '°'
    }</div>
      <div style="padding-bottom: 6px;">${t('D_LOCATION.time')}：${moment(
      device.updateTime
    ).format('YYYY-MM-DD HH:mm:ss')}</div>
    `)
    // map.panTo(latlng)
    // map.setView(latlng, 13)
    marker.openPopup()
  })

  return marker
}

// 获取点
const getPoints = (points: any) => {
  return points.map((device: any) => {
    const { longitude, latitude } = device
    return {
      lng: longitude,
      lat: latitude,
    }
  })
}

// 自动刷新
const autoFetch = ref(false)
const timer: any = ref(0)
watch(autoFetch, () => {
  if (autoFetch.value) {
    clearInterval(timer.value)
    timer.value = setInterval(() => {
      queryDeviceLocation()
    }, 1000 * 15)
  } else {
    clearInterval(timer.value)
  }
})

onUnmounted(() => {
  clearInterval(timer.value)
})

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          inline: true,
          model: formInline.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "组织名称",
              prop: "orgId"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(OrgSelect), {
                  style: {"width":"280px"},
                  class: "ws_select ws_mr15",
                  modelValue: formInline.value.orgId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.orgId) = $event)),
                  onChange: onOrgChange
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "deviceIds",
              label: _ctx.$t('D_LOCATION.deviceName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formInline.value.deviceIds,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.deviceIds) = $event)),
                  multiple: "",
                  placeholder: _ctx.$t('D_LOCATION.deviceNamePla'),
                  clearable: "",
                  filterable: "",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  style: {"width":"280px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceOps.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.deviceId,
                        label: item.deviceName,
                        value: item.deviceId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: queryDeviceLocation,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: resetForm,
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: autoFetch.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((autoFetch).value = $event)),
                  class: "ws_ml35"
                }, null, 8, ["modelValue"]),
                _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t('D_LOCATION.autoFetchText')), 1),
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: _ctx.$t('D_LOCATION.autoFetchTip'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "ws_ml10" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InfoFilled)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _hoisted_5
    ]),
    _hoisted_6,
    _createVNode(_unref(MapControl))
  ]))
}
}

})